export let AgMemberModalLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718616922481-col-1",
                elementid: "1718616967444",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              // {
              //   parentid: "1718616922481-col-2",
              //   elementid: "1718616970411",
              //   elementtype: "textfield",
              // },
              {
                parentid: "1718616961245-col-1",
                elementid: "1718616994611",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616922481",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616976561",
                elementtype: "email",
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718616984561",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616994627",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718617002793",
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616942462-col-1",
                elementid: "1718617011709",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          // {
          //   child: [
          //     {
          //       parentid: "1718616942462-col-2",
          //       elementid: "1718617014275",
          //       elementtype: "textfield",
          //     },
          //   ],
          //   colpos: 2,
          //   parentid: "1718616942462-columns",
          //   elementid: "1718616942462-col-2",
          //   elementtype: "column",
          //   colsizeclass: "col-md-6",
          // },
          {
            child: [
              {
                parentid: "1718616955479-col-1",
                elementid: "1718617024542",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616942462",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038957",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616961228-col-2",
                elementid: "1718617041258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616955479",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              // {
              //   parentid: "1718616961245-col-1",
              //   elementid: "1718616994611",
              //   elementtype: "customSelect",
              // },
              {
                parentid: "1718616961245-col-1",
                elementid: "1718616994899",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718616961245-columns",
            elementid: "1718616961245-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616955479-col-2",
                elementid: "1718617031258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let PrimaryDetailsModalLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718616922481-col-1",
                elementid: "1718616984561",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 1,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-1",
            elementtype: "column",
            colsizeclass: "col-md-12",
          },
          {
            child: [
              // {
              //   parentid: "1718616922481-col-2",
              //   elementid: "1718616970411",
              //   elementtype: "textfield",
              // },
              {
                parentid: "1718616961245-col-1",
                elementid: "1718616976561",
                elementtype: "email",
              },
            ],
            colpos: 2,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-2",
            elementtype: "column",
            colsizeclass: "col-md-12",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616922481",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let AgFamilyMemberModalLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718616922481-col-1",
                elementid: "1718616967444",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616922481-col-2",
                elementid: "1718616970411",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616922481-columns",
            elementid: "1718616922481-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616922481",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616976561",
                elementtype: "email",
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718616984561",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616994627",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718617002793",
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616942462-col-1",
                elementid: "1718617011709",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616942462-col-2",
                elementid: "1718617014275",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616942462-columns",
            elementid: "1718616942462-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616942462",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616955479-col-1",
                elementid: "1718617024542",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616955479-col-2",
                elementid: "1718617031258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616955479-columns",
            elementid: "1718616955479-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616955479",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616961228-col-1",
                elementid: "1718617038957",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616961228-col-2",
                elementid: "1718617041258",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616961228-columns",
            elementid: "1718616961228-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616961228",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
